import {
    WorkstreamDefinitionOperationConfig,
    WorkstreamDefinitionOperationConfigResponse
} from '@/pages/OperationsAdministration/types/Api/WorkstreamDefinitionOperationConfig';
import {
    WorkstreamDefinitionOperationConfigGridRow,
    WorkstreamDefinitionOperationConfigGridRowSchema
} from '@/pages/OperationsAdministration/types/WorkstreamDefinitionOperationConfigGridRow';

function transformSourcesForGrid(config: WorkstreamDefinitionOperationConfig) {
    return config.sourceFeedMetadata?.integrationSourceSummaries.map((s) => s.integrationName) ?? [];
}

/**
 * Convert single workstream definition config to grid row
 * @param config Workstream definition configs
 */
function tfConfigToRow(config: WorkstreamDefinitionOperationConfig) {
    return WorkstreamDefinitionOperationConfigGridRowSchema.parse({
        ...config,
        ...config.advancedSnapshot,
        state: config.advancedSnapshot?.isEnabled ?? false,
        sources: transformSourcesForGrid(config),
        backlogEffectiveFrom: config.backlogEffectiveFrom ?? new Date()
    });
}

/**
 * Convert array of workstream definition configs to array of grid rows
 * @param configs Array of workstream definition configs
 */
export function tfWorkstreamConfigsToRow(configs?: WorkstreamDefinitionOperationConfigResponse): WorkstreamDefinitionOperationConfigGridRow[] {
    return configs?.map((v) => tfConfigToRow(v)) ?? [];
}
